import React, {
  Children,
  useContext,
  useEffect,
  useState
} from "react";
import { Box, Typography, Card, CardContent, Grid, Tooltip } from "@mui/material";
import { FormattedMessage } from "react-intl";
import APIContext from "../../../services/api/api";
import { URLS } from "../../../configuration/urls";
import { formatNumberShort } from "../../../components/formatter";

export function VolumeHandled({ today }) {
  const [data, setData] = useState([]);
  const { getData } = useContext(APIContext);
  useEffect(() => {
    async function fetchVolumeData() {
      try {
        const volumes = await getData(
          `h7/kpi/volume-handled?currentDate=${today}`,
          {},
          URLS.EC_CLEAR_CUSTOMS_BE()
        );
        setData(volumes);
      } catch (error) {
        console.log(error);
      }
    }

    fetchVolumeData();
  }, []);

  return (
    <Box sx={{ overflow: "hidden" }}>
      <Grid container spacing={2}>
        {Children.toArray(
          data?.map?.((v, index) => {
              return (
                <Grid key={index} item xs={12} sm={6} md={3}>
                  <Card
                    sx={{
                      height: "105px",
                      alignSelf: "stretch",
                      flexGrow: 0,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      padding: "16px 16px 10px",
                      borderRadius: "12px",
                      boxShadow: "0 1px 3px 0 var(--10), 0 1px 2px -1px var(--10)",
                      border: "solid 1px var(--new-border)",
                      backgroundColor: "var(--kp-is-fubctional-background-default)",
                    }}
                  >
                    <CardContent
                      sx={{
                        width: "100%",
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        gap: "8px",
                        padding: 0,
                        "&:last-child": { paddingBottom: 0 },
                      }}
                    >
                      <Typography
                        variant="body2"
                        data-testid={`volume_handled_box${index}_heading`}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          fontSize: "20px",
                          fontWeight: 600,
                          color: "var(--font-strong-default)",
                        }}
                      >
                        <FormattedMessage id="volumeHandled" />
                      </Typography>
                      {v?.volume &&
                        <Typography
                          sx={{
                            fontFamily: "Inter",
                            fontSize: "28px",
                            fontWeight: 600,
                            textAlign: "right",
                            color: "var(--font-strong-default)",
                          }}
                          noWrap
                          data-testid={`volume_handled_box${index}_data`}
                        >
                          <Tooltip
                            placement="right"
                            title={v?.volume?.toLocaleString?.("de-DE")}>
                            {formatNumberShort(v?.volume)} KG
                          </Tooltip>
                        </Typography>
                      }
                      {!v?.volume &&
                        <Typography
                          sx={{ mt: 1, color: "var(--font-strong-default)" }}
                          noWrap
                          data-testid={`volume_handled_box${index}_data`}
                        >
                          <FormattedMessage id="noData" />
                        </Typography>
                      }
                    </CardContent>
                  </Card>
                </Grid>
              );
            }
          )
        )}
      </Grid>
    </Box>
  );
}
